import React from "react";

function Insurance2Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
    >
      <path
        d="M11.8781 0.135938C11.6813 0.046875 11.4703 0 11.25 0C11.0297 0 10.8188 0.046875 10.6219 0.135938L1.79533 3.88125C0.764084 4.31719 -0.00466618 5.33438 2.13211e-05 6.5625C0.0234588 11.2125 1.93596 19.7203 10.0125 23.5875C10.7953 23.9625 11.7047 23.9625 12.4875 23.5875C20.5641 19.7203 22.4766 11.2125 22.5 6.5625C22.5047 5.33438 21.736 4.31719 20.7047 3.88125L11.8781 0.135938ZM6.00002 10.3734C6.00002 8.78906 7.2844 7.5 8.87346 7.5C9.63283 7.5 10.3641 7.80469 10.9031 8.33906L11.25 8.68594L11.5969 8.33906C12.136 7.8 12.8672 7.5 13.6266 7.5C15.211 7.5 16.5 8.78438 16.5 10.3734C16.5 11.1328 16.1953 11.8641 15.661 12.4031L11.7844 16.2797C11.4938 16.5703 11.0156 16.5703 10.725 16.2797L6.84846 12.4031C6.3094 11.8641 6.0094 11.1328 6.0094 10.3734H6.00002Z"
        fill="white"
      />
    </svg>
  );
}

export default Insurance2Icon;
